import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from './ContextManager/Store';
import { Provider } from 'react-redux';
import './translation/i18n';
import { initAnalytics, logEvent, AnalyticsEvents } from './Utils/analyticsService';

// Initialize PostHog once, before the app renders. Self-contained and safe:
// no-ops if no key is configured and never throws.
initAnalytics();
logEvent(AnalyticsEvents.appOpened);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  /**
   * ----------------------------------------------------------------
   * React.strict mode enable react.useEffect() to load twice even when empty
   * array is passed to stop that behaviour
   * ----------------------------------------------------------------
   */
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>
);
